module.exports = __webpack_public_path__ + "img/cio-logo.47c1f030.png";